import styled from 'styled-components'
import { Utils } from '@microfrontends/react-components'

export const GotoWrapper = styled.div<{ isShow?: boolean }>`
    position: fixed;
    bottom: 100px;
    right: 33px;
    z-index: 100;
    width: 36px;
    height: 36px;
    border-radius: 20px;
    cursor: pointer;
    transition: all 0.25s ease-in-out;
    visibility: ${({ isShow }) => (isShow ? 'visible' : 'hidden')};
    opacity: ${({ isShow }) => (isShow ? 1 : 0)};
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    background: white;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 10px 0px;
    @media screen and (max-width: ${Utils.screens.mobile}px) {
        bottom: 170px;
        right: 22px;
    }
`
